import React from 'react'
import { Outlet } from 'react-router-dom'

const ProgramsLayout = () => <Outlet />

export default ProgramsLayout
